import { makeObservable, action } from "mobx";
import { Evaluation } from '../api';

export default class EvaluationStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      getEvaluation: action,
      updateEvaluationById: action
    });
  }

  async getEvaluation() {
    try {
      const retObj = await Evaluation.getEvaluations();
      return retObj.data.response.evaluations.data;
    } catch (error) {
      console.error("Error in getEvaluation:", error);
      throw error;
    }
  }

  async updateEvaluationById(id, data) {
    try {
      const retObj = await Evaluation.updateEvaluationById(id, data);
      return retObj.data.response.evaluation;
    } catch (error) {
      console.error("Error in updateEvaluationById:", error);
      throw error;
    }
  }
}
